import { OperatorFunction, Observable } from 'rxjs';
import ImageProcessingError from '@/model/ImageProcessingError';
import { filter } from 'rxjs/operators';

export default function errorsOnly<T>(): OperatorFunction<T, Extract<T, ImageProcessingError<any>>> {
    return ((source) => source.pipe(
        filter((val) => val instanceof ImageProcessingError),
    )) as OperatorFunction<T, Extract<T, ImageProcessingError<any>>>;
}
